/**
 * VisuallyHidden — content visible to assistive tech but hidden from sighted users.
 *
 * Use this instead of the legacy `text-indent:-9999px` / `display:none` hacks
 * (sb-reviews MOD-7, Social Wall SW-A13, etc.). Content remains in the
 * accessibility tree and the document flow.
 *
 * Usage:
 *
 *   <button aria-label={__('Read more', 'sb-customizer')}>
 *     ...
 *     <VisuallyHidden>{__('Read more about this post', 'sb-customizer')}</VisuallyHidden>
 *   </button>
 *
 *   <VisuallyHidden as="h2">{__('Filters', 'sb-customizer')}</VisuallyHidden>
 *
 * Reference: .pitch/wcag-accessibility-audit/react-canonical-pattern.md (PR 1).
 */
export function VisuallyHidden({ as: As = 'span', className = '', ...props }) {
    return <As className={`sb-visually-hidden ${className}`.trim()} {...props} />;
}
